import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { getUrlParamValue } from '../utils';

import { nl } from './nl';
import { fr } from './fr';

const normaliseLanguage = (value?: string | null) => {
    if (!value) return undefined;

    const lowerCaseValue = value.toLowerCase();

    if (lowerCaseValue.startsWith('fr')) {
        return 'fr';
    }

    if (lowerCaseValue.startsWith('nl')) {
        return 'nl';
    }

    return undefined;
};

const detectLanguage = () => {
    const urlLanguage = normaliseLanguage(getUrlParamValue('lng'));
    if (urlLanguage) return urlLanguage;

    if (typeof document !== 'undefined') {
        const documentLanguage = normaliseLanguage(
            document.documentElement.getAttribute('lang')
        );

        if (documentLanguage) return documentLanguage;
    }

    if (typeof window !== 'undefined') {
        try {
            const storedLanguage = normaliseLanguage(
                window.localStorage?.getItem('i18nextLng')
            );

            if (storedLanguage) return storedLanguage;
        } catch (error) {
            // Access to localStorage can fail (e.g. disabled cookies); ignore.
        }
    }

    return 'nl';
};

export const initI18n = () =>
    i18n.use(initReactI18next).init({
        lng: detectLanguage(),
        resources: {
            nl: {
                translation: nl,
            },
            fr: {
                translation: fr,
            },
        },
        fallbackLng: 'nl',
        debug: process.env.NODE_ENV === 'development',
    });

export { i18n };

i18n.on('languageChanged', (language) => {
    if (typeof document !== 'undefined') {
        document.documentElement.setAttribute('lang', language);
    }
});
